<div class="modal-dialog container">
  <div class="modal-content">
    <div class="modal-header">Create Directories</div>

    <div class="modal-body cl-form">
      <label for="dirs" class="form-label">Directory name(s)</label>
      <textarea id="dirs" [(ngModel)]="new_dir_name" cdkAutosizeMaxRows="5"
                cdkAutosizeMinRows="2"
                cdkTextareaAutosize></textarea>
      <p class="valid-feedback">Create multiple directories by entering one directory per line.</p>
    </div>
    <div class="modal-footer">
      <span class="modal-footer-left">
                    <button type="button" class="btn cl-color-secondary it-cancel"
                            (click)="dialogRef.close()">
                      <span>Cancel</span>
                    </button></span>
      <span class="modal-footer-center"></span>
      <span class="modal-footer-right">
                    <button type="button" class="btn cl-color-primary" [class.cl-btn-spinner]="mkdiring"
                            (click)="mkdir();"
                            [disabled]="!buttonEnabled || mkdiring"
                    >
                        <span>Create directories</span>
                    </button></span>
    </div>
  </div>
</div>
